// @ts-ignore
import packageJson from "../package.json";

export const LIBRARY_NAME = packageJson.name;
export const LIBRARY_VERSION = packageJson.version;
